import Tracker from "../prop-trackers/tracker.js";
import TrackerGroup from "../prop-trackers/tracker-group.js";

class ValueTracker extends Tracker {
    constructor() {
        super();
    }

    setValue(newValue) {
        throw new Error("Method .setValue is not implemented");
    }

    deleteValue() {
        throw new Error("Method .deleteValue is not implemented");
    }
}

class ForEach extends Tracker {
    constructor(rootTracker, createValueTracker) {
        super();

        this._rootTracker = rootTracker;
        this._createValueTracker = createValueTracker;

        this._trackers = new Map();
        this._trackerGroup = new TrackerGroup();

        const needsUpdate = this.protected_needsUpdate.bind(this);
        rootTracker.listenNeedsUpdate(needsUpdate);
        this._trackerGroup.listenNeedsUpdate(needsUpdate);
    }

    protected_startUpdate() {
        const { props: rootProps } = this._rootTracker.startUpdate();

        for (const { key, oldExists, newExists, newValue } of rootProps.iterateModified()) {
            let tracker;

            if (!oldExists && newExists) {
                tracker = this._createValueTracker(key);
                this._trackers.set(key, tracker);
                this._trackerGroup.add(tracker);
            }

            if (oldExists) {
                tracker = this._trackers.get(key);
            }

            if (newExists) {
                tracker.setValue(newValue);
            } else {
                tracker.deleteValue();
            }

            if (oldExists && !newExists) {
                this._trackers.delete(key);
                this._trackerGroup.remove(tracker);
            }
        }

        this._rootTracker.finishUpdate();

        return this._trackerGroup.startUpdate();
    }

    protected_finishUpdate() {
        this._trackerGroup.finishUpdate();
    }
}

ForEach.ValueTracker = ValueTracker;

export default ForEach;
export { ForEach, ValueTracker };
